module.exports = __webpack_public_path__ + "img/btnStatus2.17da9225.png";